
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import EventPopup from '../../components/feature/EventPopup';
import HeroSection from './components/HeroSection';
import CafeHighlight from './components/CafeHighlight';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import LocationSection from './components/LocationSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <EventPopup />
      <Header />
      <main>
        <HeroSection />
        <CafeHighlight />
        <WhyChooseUs />
        <Testimonials />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}
